import request from '@/axios'

export function getPredefinedWidgetList () {
  return request({
    url: 'dashboard/predefinedCard',
    method: 'GET'
  })
}

export function enablePredefinedWidget (customer_id, payload) {
  return request({
    url: `dashboard/addPredefinedCard/${customer_id}`,
    method: 'POST',
    data: payload
  })
}

export function createDashboardCard (customer_id, payload) {
  return request({
    url: `dashboard/create/${customer_id}`,
    method: 'POST',
    data: payload
  })
}

export function getAllDisplayedDashboardCards (customer_id) {
  return request({
    url: `dashboard/list/${customer_id}`,
    method: 'GET'
  })
}

export function updateCardSize (customer_id, payload) {
  return request({
    url: `dashboard/updateCardWidth/${customer_id}`,
    method: 'POST',
    data: payload
  })
}

export function updateCardOrder (customer_id, payload) {
  return request({
    url: `dashboard/reOrderDashBoard/${customer_id}`,
    method: 'POST',
    data: payload
  })
}

export function deleteDashboardCard (customer_id, payload) {
  return request({
    url: `dashboard/delete/${customer_id}`,
    method: 'POST',
    data: payload
  })
}

export function fetchTeacheAttendance (customer_id, payload, query) {
  return request({
    url: `V1/dashboard/teacher/attendance/${customer_id}?page=${query.current_page}&limit=${query.limit}`,
    method: 'POST',
    data: payload
  })
}

export function fetchStudentAttendance (customer_id, payload, query) {
  return request({
    url: `V1/dashboard/student/attendance/${customer_id}?page=${query.current_page}&limit=${query.limit}`,
    method: 'POST',
    data: payload
  })
}

export function fetchLessons (customer_id, payload, query) {
  return request({
    url: `V1/dashboard/lessons/upcoming/${customer_id}?page=${query.current_page}`,
    method: 'POST',
    data: payload
  })
}

export function fetchLessonTime (customer_id) {
  return request({
    url: `V1/dashboard/today/activity/${customer_id}`,
    method: 'POST'
  })
}

export function fetchReceivedAssignment (customer_id, payload, query) {
  return request({
    url: `V1/dashboard/list/assignment/${customer_id}?page=${query.current_page}`,
    method: 'POST',
    data : payload
  })
}